/* eslint-disable prettier/prettier */
<template>
  <fragment id="App" class>
    <!-- <transition name="fade" mode="out-in"> -->
    <!-- <transition name="slide-left" mode="out-in"> -->
    <router-view :key="$route.fullPath" />
    <!-- </transition> -->

    <!-- </transition> -->
    <div class="global-canvas-class">
      <canvas id="global-canvas" style="width: 100%; height: 100%"></canvas>
    </div>
    <MsgAfterBought :messageId="messageId" />
    <MsgAfterLogin />
    <LoginModal />
    
  </fragment>
</template>
<script>
import Swal from 'sweetalert2';
import $ from 'jquery';

import store from './global/store';
import { mapGetters, mapActions } from 'vuex';
//import { trackingVendor } from '@/global/fingerPrint';
import { cookieSetItemInfinity, cookieGetItem } from '@/global/cookie';

import { LOGIN_PAGE_CHUNK_NAME } from './constants';
import { LOGIN_PAGE } from './constants/routes';
import MsgAfterBought from '@/components/MsgAfterBought.vue';
import MsgAfterLogin from '@/components/MsgAfterLogin.vue';
import LoginModal from '@/components/LoginModal.vue';

function GetQueryValue(queryName) {
  var query = decodeURI(window.location.search.substring(1));
  var vars = query.split('&');
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=');
    if (pair[0] == queryName) {
      return pair[1];
    }
  }
  return null;
}

export default {
  components: {
    MsgAfterBought,
    MsgAfterLogin,
    LoginModal,
  },

  data: () => {
    return {
      msgIdx: -1,
      messageId: 0,
    };
  },

  computed: {
    ...mapGetters([
      'loading',
      'pzError',
      'importantMessageCount',
      'importantMessageList',
      'afterLoginComplete',
      'version',
    ]),
  },

  watch: {
    pzError: function (current) {
      if (current && current.message) {
        if (current.code == 401 || current.code == 403) {
          Swal.fire({
            icon: 'info',
            title: current.message,
            confirmButtonColor: '#3085d6',
            confirmButtonText: '重新登录',
          }).then((result) => {
            if (result.value) {
              store.dispatch('logoutFromData');
              if (LOGIN_PAGE_CHUNK_NAME !== this.$route.name) {
                this.$router.push(
                  LOGIN_PAGE +
                    '?login_redirect_uri=' +
                    encodeURIComponent(this.$route.fullPath)
                );
              }
              // window.parent.postMessage(
              //   { message: 'comlogout' },
              //   'http://www.pzacademy.cn'
              // );
            }
          });
        } else if (current.code == 500) {
          Swal.fire({
            icon: 'info',
            title: current.message,
          }).then((result) => {
            if (result.value) {
              window.location.reload();
            }
          });
        } else {
          Swal.fire({
            icon: 'info',
            title: current.message,
          });
        }
      }
    },

    afterLoginComplete(v, ov) {
      if (false === ov && true == v) {
        //this.getImportantMessage();
      }
    },

    importantMessageCount(v, ov) {
      if (0 === ov && 0 !== v) {
        if (0 < v) {
          this.msgIdx = 0;
          this.showMsg();
        }
      }
    },
  },

  mounted() {
    const vendorId = GetQueryValue('vendorid');
    //const currentUrl = window.location.href;

    if (vendorId) {
      //trackingVendor(parseInt(vendorId), currentUrl);
      cookieSetItemInfinity('vendorId', vendorId);
    }
  },

  created() {
    // this.mg_getVersion();
  },

  methods: {
    ...mapActions(['getImportantMessage', 'readImportantMessage', 'getVersion']),

    // async mg_getVersion() {
    //   await this.getVersion();
    //   const version = cookieGetItem('version');
    //   if (this.version != version) {
    //     cookieSetItemInfinity('version', this.version);
    //     window.location.reload();
    //   }
    // },

   

    showMsg() {
      const msg = this.importantMessageList[this.msgIdx];
      if (msg.isSentAfterBuy && msg.messageType == 4) {
        $(`#msgAfterBought`).modal('show');
        this.messageId = msg.messageId;
      } else {
        $(`#msgAfterLogin`).modal('show');
        //this.messageId = msg.messageId;
        //Swal.fire({
        //  title:
        //    `<span>(${this.msgIdx + 1}/${this.importantMessageCount})</span>` +
        //    msg.messageTitle,
        //  html: msg.messageContent,
        //  confirmButtonColor: '#3085d6',
        //  confirmButtonText: '我知道了',
        //  allowOutsideClick: false,
        //}).then((result) => {
        //  if (result.value) {
        //    this.readImportantMessage({
        //      messageId: msg.messageId,
        //    });
        //    this.msgIdx++;
        //    if (this.importantMessageCount > this.msgIdx) {
        //      this.showMsg();
        //    } else {
        //      this.msgIdx = -1;
        //    }
        //  }
        //});
      }
    },
  },
};
</script>
<style scoped lang="scss">
.global-canvas-class {
  left: 0px !important;
  top: 0px !important;
  position: fixed !important;
  z-index: 200000 !important;
  pointer-events: none !important;
  width: 100%;
  height: 100%;
  right: 0px !important;
  bottom: 0px !important;
  -webkit-filter: Alpha(opacity=0) !important;
  filter: Alpha(opacity=0) !important;
}

.blocker {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: #000;
  z-index: 9999;
  opacity: 0;
}

.cube-container {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 10000;
  opacity: 1;
  background: #009688;
  background: -webkit-linear-gradient(to left, #5cc1b8, #009688);
  background: linear-gradient(to left, #5cc1b8, #009688);
}

.cube-folding {
  width: 50px;
  height: 50px;
  display: inline-block;
  -moz-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  font-size: 0;
}

.cube-folding span {
  position: relative;
  width: 25px;
  height: 25px;
  -moz-transform: scale(1.1);
  -ms-transform: scale(1.1);
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
  display: inline-block;
}

.cube-folding span::before {
  content: '';
  background-color: white;
  position: absolute;
  left: 0;
  top: 0;
  display: block;
  width: 25px;
  height: 25px;
  -moz-transform-origin: 100% 100%;
  -ms-transform-origin: 100% 100%;
  -webkit-transform-origin: 100% 100%;
  transform-origin: 100% 100%;
  -moz-animation: folding 2.5s infinite linear both;
  -webkit-animation: folding 2.5s infinite linear both;
  animation: folding 2.5s infinite linear both;
}

.cube-folding .leaf2 {
  -moz-transform: rotateZ(90deg) scale(1.1);
  -ms-transform: rotateZ(90deg) scale(1.1);
  -webkit-transform: rotateZ(90deg) scale(1.1);
  transform: rotateZ(90deg) scale(1.1);
}

.cube-folding .leaf2::before {
  -moz-animation-delay: 0.3s;
  -webkit-animation-delay: 0.3s;
  animation-delay: 0.3s;
  background-color: #f2f2f2;
}

.cube-folding .leaf3 {
  -moz-transform: rotateZ(270deg) scale(1.1);
  -ms-transform: rotateZ(270deg) scale(1.1);
  -webkit-transform: rotateZ(270deg) scale(1.1);
  transform: rotateZ(270deg) scale(1.1);
}

.cube-folding .leaf3::before {
  -moz-animation-delay: 0.9s;
  -webkit-animation-delay: 0.9s;
  animation-delay: 0.9s;
  background-color: #f2f2f2;
}

.cube-folding .leaf4 {
  -moz-transform: rotateZ(180deg) scale(1.1);
  -ms-transform: rotateZ(180deg) scale(1.1);
  -webkit-transform: rotateZ(180deg) scale(1.1);
  transform: rotateZ(180deg) scale(1.1);
}

.cube-folding .leaf4::before {
  -moz-animation-delay: 0.6s;
  -webkit-animation-delay: 0.6s;
  animation-delay: 0.6s;
  background-color: #e6e6e6;
}

@-moz-keyframes folding {
  0%,
  10% {
    -moz-transform: perspective(140px) rotateX(-180deg);
    transform: perspective(140px) rotateX(-180deg);
    opacity: 0;
  }
  25%,
  75% {
    -moz-transform: perspective(140px) rotateX(0deg);
    transform: perspective(140px) rotateX(0deg);
    opacity: 1;
  }
  90%,
  100% {
    -moz-transform: perspective(140px) rotateY(180deg);
    transform: perspective(140px) rotateY(180deg);
    opacity: 0;
  }
}

@-webkit-keyframes folding {
  0%,
  10% {
    -webkit-transform: perspective(140px) rotateX(-180deg);
    transform: perspective(140px) rotateX(-180deg);
    opacity: 0;
  }
  25%,
  75% {
    -webkit-transform: perspective(140px) rotateX(0deg);
    transform: perspective(140px) rotateX(0deg);
    opacity: 1;
  }
  90%,
  100% {
    -webkit-transform: perspective(140px) rotateY(180deg);
    transform: perspective(140px) rotateY(180deg);
    opacity: 0;
  }
}

@keyframes folding {
  0%,
  10% {
    -moz-transform: perspective(140px) rotateX(-180deg);
    -ms-transform: perspective(140px) rotateX(-180deg);
    -webkit-transform: perspective(140px) rotateX(-180deg);
    transform: perspective(140px) rotateX(-180deg);
    opacity: 0;
  }
  25%,
  75% {
    -moz-transform: perspective(140px) rotateX(0deg);
    -ms-transform: perspective(140px) rotateX(0deg);
    -webkit-transform: perspective(140px) rotateX(0deg);
    transform: perspective(140px) rotateX(0deg);
    opacity: 1;
  }
  90%,
  100% {
    -moz-transform: perspective(140px) rotateY(180deg);
    -ms-transform: perspective(140px) rotateY(180deg);
    -webkit-transform: perspective(140px) rotateY(180deg);
    transform: perspective(140px) rotateY(180deg);
    opacity: 0;
  }
}

.cube-wrapper {
  position: fixed;
  left: 50%;
  top: 50%;
  margin-top: -50px;
  margin-left: -50px;
  width: 100px;
  height: 100px;
  text-align: center;
}

.cube-wrapper:after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: -20px;
  margin: auto;
  width: 90px;
  height: 6px;
  background-color: rgba(0, 0, 0, 0.1);
  -webkit-filter: blur(2px);
  filter: blur(2px);
  -moz-border-radius: 100%;
  -webkit-border-radius: 100%;
  border-radius: 100%;
  z-index: 1;
  -moz-animation: shadow 0.5s ease infinite alternate;
  -webkit-animation: shadow 0.5s ease infinite alternate;
  animation: shadow 0.5s ease infinite alternate;
}

.cube-wrapper .loading {
  font-size: 12px;
  letter-spacing: 0.1em;
  display: block;
  color: white;
  position: relative;
  top: 25px;
  z-index: 2;
  -moz-animation: text 0.5s ease infinite alternate;
  -webkit-animation: text 0.5s ease infinite alternate;
  animation: text 0.5s ease infinite alternate;
}

@-moz-keyframes text {
  100% {
    top: 35px;
  }
}

@-webkit-keyframes text {
  100% {
    top: 35px;
  }
}

@keyframes text {
  100% {
    top: 35px;
  }
}

@-moz-keyframes shadow {
  100% {
    bottom: -18px;
    width: 100px;
  }
}

@-webkit-keyframes shadow {
  100% {
    bottom: -18px;
    width: 100px;
  }
}

@keyframes shadow {
  100% {
    bottom: -18px;
    width: 100px;
  }
}

html,
body {
  min-height: 100%;
}

body {
  background: #00c6ff;
  /* fallback for old browsers */
  background: -webkit-linear-gradient(to left, #00c6ff, #0072ff);
  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to left, #00c6ff, #0072ff);
  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  font-family: arial;
}

h1 {
  font-size: 26px;
  display: block;
  text-align: center;
  color: #fff;
  padding: 50px 20px;
  font-weight: 300;
  font-family: 'Archivo Narrow', sans-serif;
}

.made-with-love {
  position: fixed;
  left: 0;
  width: 100%;
  bottom: 10px;
  text-align: center;
  font-size: 10px;
  z-index: 9999;
  font-family: arial;
  color: #fff;
}

.made-with-love i {
  font-style: normal;
  color: #f50057;
  font-size: 14px;
  position: relative;
  top: 2px;
}

.made-with-love a {
  color: #fff;
  text-decoration: none;
}

.made-with-love a:hover {
  text-decoration: underline;
}

.sk-cube-grid {
  width: 60px;
  height: 60px;
  margin: 0px auto;
}

.sk-cube-grid .sk-cube {
  width: 33%;
  height: 33%;
  background-color: #fff;
  float: left;
  -webkit-animation: sk-cubeGridScaleDelay 1.3s infinite ease-in-out;
  animation: sk-cubeGridScaleDelay 1.3s infinite ease-in-out;
}

.sk-cube-grid .sk-cube1 {
  -webkit-animation-delay: 0.2s;
  animation-delay: 0.2s;
}

.sk-cube-grid .sk-cube2 {
  -webkit-animation-delay: 0.3s;
  animation-delay: 0.3s;
}

.sk-cube-grid .sk-cube3 {
  -webkit-animation-delay: 0.4s;
  animation-delay: 0.4s;
}

.sk-cube-grid .sk-cube4 {
  -webkit-animation-delay: 0.1s;
  animation-delay: 0.1s;
}

.sk-cube-grid .sk-cube5 {
  -webkit-animation-delay: 0.2s;
  animation-delay: 0.2s;
}

.sk-cube-grid .sk-cube6 {
  -webkit-animation-delay: 0.3s;
  animation-delay: 0.3s;
}

.sk-cube-grid .sk-cube7 {
  -webkit-animation-delay: 0s;
  animation-delay: 0s;
}

.sk-cube-grid .sk-cube8 {
  -webkit-animation-delay: 0.1s;
  animation-delay: 0.1s;
}

.sk-cube-grid .sk-cube9 {
  -webkit-animation-delay: 0.2s;
  animation-delay: 0.2s;
}

@-webkit-keyframes sk-cubeGridScaleDelay {
  0%,
  70%,
  100% {
    -webkit-transform: scale3D(1, 1, 1);
    transform: scale3D(1, 1, 1);
  }
  35% {
    -webkit-transform: scale3D(0, 0, 1);
    transform: scale3D(0, 0, 1);
  }
}

@keyframes sk-cubeGridScaleDelay {
  0%,
  70%,
  100% {
    -webkit-transform: scale3D(1, 1, 1);
    transform: scale3D(1, 1, 1);
  }
  35% {
    -webkit-transform: scale3D(0, 0, 1);
    transform: scale3D(0, 0, 1);
  }
}

.preloader {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  background-color: #fff;
  z-index: 99999;
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.status {
  position: absolute;
  left: calc(50% - 25px);
  top: calc(50% - 30px);
  margin: auto;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
  background: #009688;
  animation: 1.15s infinite ease-in-out;
  -webkit-animation: 1.15s infinite ease-in-out;
  -moz-animation: 1.15s infinite ease-in-out;
  animation-name: loader;
  -webkit-animation-name: loader;
  -moz-animation-name: loader;
}

.status:after,
.status:before {
  animation: 1.15s infinite ease-in-out;
  -webkit-animation: 1.15s infinite ease-in-out;
  -moz-animation: 1.15s infinite ease-in-out;
}

.status:after,
.status:before {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  position: absolute;
  top: 0;
  left: 0;
}

.preloader .loading {
  font-size: 12px;
  letter-spacing: 0.1em;
  display: block;
  color: white;
  position: relative;
  top: 25px;
  z-index: 2;
  -moz-animation: text 0.5s ease infinite alternate;
  -webkit-animation: text 0.5s ease infinite alternate;
  animation: text 0.5s ease infinite alternate;
}

@keyframes loader {
  from {
    transform: scale(0);
    opacity: 1;
  }

  to {
    transform: scale(1);
    opacity: 0.5;
  }
}

@-ms-keyframes loader {
  from {
    -ms-transform: scale(0);
    opacity: 1;
  }

  to {
    -ms-transform: scale(1);
    opacity: 0.5;
  }
}

@-webkit-keyframes loader {
  from {
    -webkit-transform: scale(0);
    opacity: 1;
  }

  to {
    -webkit-transform: scale(1);
    opacity: 0.5;
  }
}

@-moz-keyframes loader {
  from {
    -moz-transform: scale(0);
    opacity: 1;
  }

  to {
    -moz-transform: scale(1);
    opacity: 0.5;
  }
}
</style>
